(() => {
  // --- Helpers ---
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function findProductJSON(rootEl) {
    // Cari script JSON terdekat yang berisi variants
    const scripts = qsa('script[type="application/json"]', rootEl);
    for (const s of scripts) {
      const t = (s.textContent || '').trim();
      if (!t) continue;
      // heuristik: harus ada "variants" dan minimal "id"
      if (t.includes('"variants"') && t.includes('"id"')) {
        try {
          const data = JSON.parse(t);
          if (data && Array.isArray(data.variants)) return data;
        } catch (e) {}
      }
    }

    // fallback: cari di seluruh halaman
    const all = qsa('script[type="application/json"]');
    for (const s of all) {
      const t = (s.textContent || '').trim();
      if (!t) continue;
      if (t.includes('"variants"') && t.includes('"id"')) {
        try {
          const data = JSON.parse(t);
          if (data && Array.isArray(data.variants)) return data;
        } catch (e) {}
      }
    }
    return null;
  }

  function getSelectedValue(form, names) {
    for (const name of names) {
      // radio checked
      const r = qs(`input[type="radio"][name="${CSS.escape(name)}"]:checked`, form);
      if (r) return r.value;

      // select
      const s = qs(`select[name="${CSS.escape(name)}"]`, form);
      if (s) return s.value;
    }
    return null;
  }

  function setOptionChecked(form, optionNameCandidates, value) {
    for (const name of optionNameCandidates) {
      const r = qs(`input[type="radio"][name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`, form);
      if (r) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      const s = qs(`select[name="${CSS.escape(name)}"]`, form);
      if (s) {
        s.value = value;
        s.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function updateVariantIdAndURL(form, variantId) {
    const idInput = qs('input[name="id"]', form);
    if (!idInput) return false;

    const prev = idInput.value;
    idInput.value = String(variantId);

    // Trigger change so theme refreshes price/media if it listens
    idInput.dispatchEvent(new Event('change', { bubbles: true }));

    // Update URL parameter ?variant=...
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    return prev !== String(variantId);
  }

  function setRadioAndActive(form, nameCandidates, value) {
  for (const name of nameCandidates) {
    const inputs = Array.from(form.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`));
    if (!inputs.length) continue;

    const target = inputs.find(r => r.value === value);
    if (!target) continue;

    // 1) Check radio
    target.checked = true;

    // 2) Update wrapper "active" (Morata pakai div.product-options__value)
    const wrap = target.closest('.product-options__value');
    if (wrap) {
      // hapus active dari semua pilihan dalam section yg sama
      const section = wrap.closest('.product-options__section') || form;
      section.querySelectorAll('.product-options__value.active').forEach(el => el.classList.remove('active'));
      wrap.classList.add('active');
    }

    // 3) Trigger change biar theme update price/media juga
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  return false;
}


  // --- Core logic ---
  function autoSwitchOnColorChange(e) {
    const t = e.target;
    if (!t) return;

    // hanya respons untuk perubahan color (radio/select)
    const isColor = (t.matches('input[type="radio"][name="Color"]') || t.matches('select[name="Color"]') ||
                     t.name === 'Color' || t.name === 'options[Color]' || t.name === 'option1' || t.name === 'option2' || t.name === 'option3');

    if (!isColor) return;

    const form = t.closest('form');
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    const root = form.closest('section, .shopify-section, .product, main, body') || document;
    const product = findProductJSON(root);
    if (!product || !Array.isArray(product.variants)) return;

    // Kandidat nama field option yang umum (theme beda-beda)
    const colorNames = ['Color', 'options[Color]', 'option1', 'option2', 'option3'];
    const sizeNames  = ['Size', 'options[Size]', 'option1', 'option2', 'option3'];

    const selectedColor = getSelectedValue(form, colorNames);
    const selectedSize  = getSelectedValue(form, sizeNames);

    if (!selectedColor) return;

    const variants = product.variants;

    // Helper: cocokkan option (option1/2/3) tanpa asumsi posisinya
    const hasValue = (v, val) => [v.option1, v.option2, v.option3].includes(val);

    // 1) Cari variant yang match color+size saat ini
    let vMatch = null;
    if (selectedSize) {
      vMatch = variants.find(v => hasValue(v, selectedColor) && hasValue(v, selectedSize));
    }

    // Kalau match ada dan available, commit (biar URL berubah konsisten)
    if (vMatch && vMatch.available) {
      updateVariantIdAndURL(form, vMatch.id);
      return;
    }

    // 2) Kalau kombinasi invalid/unavailable: pilih variant available pertama yang punya color itu
    const vFirst = variants.find(v => hasValue(v, selectedColor) && v.available);
    if (!vFirst) return;

    // Cari size yang “berpasangan” (value selain color) untuk diset ke UI
    const options = [vFirst.option1, vFirst.option2, vFirst.option3].filter(Boolean);
    const inferredSize = options.find(x => x !== selectedColor) || null;

    // Set size UI dulu (supaya tampilan sinkron), lalu set variant id + URL
    if (inferredSize) {
  setRadioAndActive(form, ['Size', 'options[Size]'], inferredSize);
}


    updateVariantIdAndURL(form, vFirst.id);
  }

  // Pasang listener global (capture) supaya nggak ketahan handler lain
  document.addEventListener('change', autoSwitchOnColorChange, true);

  // Bonus: kalau theme kamu toggle class on click tapi gak memicu change, kita bantu paksa:
  document.addEventListener('click', (e) => {
    const box = e.target.closest('.product-options__value');
    if (!box) return;
    const input = box.querySelector('input[type="radio"]');
    if (!input) return;
    // pastikan radio benar-benar checked dan memicu change
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);
})();
